// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xk_a bhp_vp bhp_vh bhp_xe bhp_rg bhp_tr bhp_qx"};